import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { FilterConfigService, type FilterDataResult, SearchFilterModel } from '@ui/shared/util-filter';
import type { PreventionListFilterKey } from '../../types/prevention-list-filters';

@Injectable({ providedIn: 'root' })
export class SearchFilterConfigService extends FilterConfigService<PreventionListFilterKey, undefined> {
    public override placeholder = 'Name des Angebotes';

    constructor() {
        super(
            new SearchFilterModel('search', 'Suchbegriff', []),
            undefined,
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of({ data: [] });
    }
}
